import '../styles/header.scss'

export function Header() {
  return (
    <header className="header">
      <div>
        <img src="https://guilhermeillescas.dev/others/logo-todo.svg" alt="to.do"/>
      </div>
    </header>
  )
}